import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { URLsConfig } from '../URLsConfig';
import { TreatmentGroupHDModel } from '../models/TreatmentGroupHDModel';
@Injectable({
  providedIn: 'root'
})
export class TreatmentGroupHDService {

constructor(private http:HttpClient, public urlsconfig : URLsConfig) { }

   public getTreatmentGroupHD(tgcode: string , compcode :string){
      let params = new HttpParams();
      params = params.append ("tgcode", tgcode);
      params = params.append("compcode",compcode);
      const options = {
        params : params
      };

      return this.http.get<TreatmentGroupHDModel>(this.urlsconfig.WebAPIURL_Test+ "api/TreatmentGroupHD/GetTreatmentGroupHD", options);
    }
  public AddTreatmentGroupHD(TreatmentGroupHD :TreatmentGroupHDModel ) {
    return this.http.post<TreatmentGroupHDModel>(this.urlsconfig.WebAPIURL_Test+"api/TreatmentGroupHD/AddTreatmentGroupHD",TreatmentGroupHD)
  }

  public DeleteTreatmentGroupHD(tgcode : string , compcode : string){
    let params = new HttpParams();
    params = params.append("tgcode", tgcode);
    params = params.append("compcode", compcode);

    const options= {
      params :params
    };

    return this.http.get<TreatmentGroupHDModel>(this.urlsconfig.WebAPIURL_Test+"api/TreatmentGroupHD/DeleteTreatmentGroupHD", options)

  }



  public GetTreatmentGroupHDLookUp(tgcode:string,tgname:string,compcode:string){
    let params = new HttpParams();
    params = params.append("tgcode",tgcode);
    params = params.append("tgname",tgname);
    params = params.append("compcode",compcode);
    const options = {
      params : params
    };
    return this.http.get<TreatmentGroupHDModel[]>(this.urlsconfig.WebAPIURL_Test+ "api/TreatmentGroupHD/TreatmentGroupHDLookup", options);

  }




  public GetTreatmentGroupHDLookupTop(compcode:string){
    let params = new HttpParams();
    debugger;
    params = params.append("compCode", compcode.trim())
        const options = {
      params : params
    };
    return this.http.get<TreatmentGroupHDModel[]>(this.urlsconfig.WebAPIURL_Test+ "api/TreatmentGroupHD/TreatmentGroupHDLookupTop", options);
  }



}

